import moment from 'moment';

export default function getDemoDate(date?: number | null) {
    const dataTime = moment(date);
    const currentTime = moment();
    const currentHour = currentTime.get('hour');
    const hour = dataTime.get('hour');
    const minute = dataTime.get('minute');
    const second = dataTime.get('second');
    const millisecond = dataTime.get('millisecond');
    const isToday = currentHour - hour > 0;
    if (!isToday) currentTime.subtract(1, 'd');
    currentTime.set({ hour, minute, second, millisecond });
    return currentTime.toDate().getTime();
}
